import * as React from "react";
import { PaginationState } from "./WizardPagination.types";
import { StepState, StepWizardNavChildProps } from "../WizardStepper.types";
import { Previous } from "./Previous";
import { Next } from "./Next";

export class WizardPagination extends React.Component<
  StepWizardNavChildProps,
  PaginationState
> {
  constructor(props: any) {
    super(props);
  }

  private readonly paginationClass = this.props.hidePagination
    ? "pagination pagination--ombud"
    : "pagination";
  private readonly paginationListItemClass = this.props.hidePagination
    ? "pagination__list-item pagination__list-item--ombud"
    : "pagination__list-item";

  public changeStep = (
    stepId: number,
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();
    this.props.goToStep(stepId);
  };

  private getClassNames = (step: StepState) => {
    let classNames = "pagination__link";
    if (step.stepId === this.getCurrentStepIndex())
      classNames += " pagination__link--active";
    return classNames;
  };

  private renderStep = (step: StepState, index: number) => {
    return (
      <li key={step.stepId} className="pagination__list-item">
        {this.getCurrentStepIndex() !== index && (
          <a
            href="#"
            onClick={(e) => this.changeStep(step.stepId, e)}
            className={this.getClassNames(step)}
          >
            {index + 1}
          </a>
        )}
        {this.getCurrentStepIndex() === index && (
          <span className={this.getClassNames(step)}>{index + 1}</span>
        )}
      </li>
    );
  };

  private getCurrentStepIndex = () => {
    return this.props.currentStep;
  };

  onClickSave = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  public render() {
    return (
      <nav
        className={this.paginationClass}
        aria-label="Navigera mellan formulärets olika steg"
      >
        <ol className="pagination__list">
          <li className={this.paginationListItemClass}>
            <Previous
              showButtons={this.props.hidePagination}
              paginationSteps={this.props.steps}
              changeStepCallback={this.changeStep}
              previousLabel={this.props.previousLabel}
              currentStepIndex={this.getCurrentStepIndex()}
            />
          </li>
          {!this.props.hidePagination &&
            this.props.steps &&
            this.props.steps.map(this.renderStep)}
          <li className={this.paginationListItemClass}>
            {(!this.props.hidePagination ||
              (this.props.hidePagination &&
                this.getCurrentStepIndex() !== 2)) && (
              <Next
                showButtons={this.props.hidePagination}
                paginationSteps={this.props.steps}
                changeStepCallback={this.changeStep}
                nextLabel={this.props.nextLabel}
                stepLength={this.props.steps.length}
                currentStepIndex={this.getCurrentStepIndex()}
              />
            )}
          </li>
        </ol>
      </nav>
    );
  }
}
